export default __webpack_public_path__ + "static/media/models4.94ae8858.png";